import { OffsetPaginationEntity } from "@/entities/OffsetPaginationEntity";
import assignOffsetPagination from "@/schemas/assignOffsetPagination";
import { MediaEntity } from "@apps/iloom_customization/design_feed/entities/MediaEntity";
import { MediaSchema } from "@apps/iloom_customization/design_feed/schemas/MediaSchema";
import { iloomCustomizationAuthApiClientToken } from "@apps/iloom_customization/tokens";
import { QueryPaginationMeta } from "@apps/iloom_customization/types/PaginationMeta";
import AuthApiClient from "@lib/ApiClient/AuthApiClient";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { create } from "superstruct";
import { inject, injectable } from "tsyringe";

export type GetMediaListQueryParams = QueryPaginationMeta & {
    collections?: string[];
    tags?: string[];
};

export type ReactionPayload = {
    productId: number;
    variantId: number;
};

@injectable()
export class DesignFeedApiService {
    public constructor(
        @inject(iloomCustomizationAuthApiClientToken)
        private readonly apiClient: AuthApiClient
    ) {}

    getMediaList(
        queryParams?: GetMediaListQueryParams
    ): Observable<OffsetPaginationEntity<MediaEntity>> {
        return this.apiClient
            .get({
                url: "/media-feed-storefront/getMediaList",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((value) =>
                    create(value.body, assignOffsetPagination(MediaSchema))
                )
            );
    }

    getCustomerMediaList(
        queryParams: QueryPaginationMeta
    ): Observable<OffsetPaginationEntity<MediaEntity>> {
        return this.apiClient
            .get({
                url: "/media-feed-storefront/fave/getCustomerMediaList",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((value) =>
                    create(value.body, assignOffsetPagination(MediaSchema))
                )
            );
    }

    addReaction({ productId, variantId }: ReactionPayload) {
        return this.apiClient.post({
            url: "/media-feed-storefront/reaction/addReaction",
            body: JSON.stringify({
                productId,
                variantId,
            }),
            contentType: "application/json",
            responseType: "json",
        });
    }

    removeReaction({ productId, variantId }: ReactionPayload) {
        return this.apiClient.post({
            url: "/media-feed-storefront/reaction/removeReaction",
            body: JSON.stringify({
                productId,
                variantId,
            }),
            contentType: "application/json",
            responseType: "json",
        });
    }

    addFave(mediaId: string) {
        return this.apiClient.post({
            url: "/media-feed-storefront/fave/addFave",
            body: JSON.stringify({
                mediaId,
            }),
            contentType: "application/json",
            responseType: "json",
        });
    }

    removeFave(mediaId: string) {
        return this.apiClient.post({
            url: "/media-feed-storefront/fave/removeFave",
            body: JSON.stringify({
                mediaId,
            }),
            contentType: "application/json",
            responseType: "text",
        });
    }
}
